import React, { ReactElement } from 'react';
import PropTypes from 'prop-types';
import { WixStyleReactMaskingProviderProps } from './WixStyleReactMaskingProvider.types';
import { maskingClassNames } from './constants';
import { WixStyleReactMaskingContext } from './context';

const WixStyleReactMaskingProvider = ({
  children,
}: WixStyleReactMaskingProviderProps): ReactElement => (
  <WixStyleReactMaskingContext.Provider value={{ maskingClassNames }}>
    {children}
  </WixStyleReactMaskingContext.Provider>
);

WixStyleReactMaskingProvider.displayName = 'WixStyleReactMaskingProvider';

WixStyleReactMaskingProvider.propTypes = {
  /** any content to be displayed */
  children: PropTypes.node,
};

export default WixStyleReactMaskingProvider;
